<template>
  <div class="flex h-screen">
    <!-- Sidebar affichée sauf sur /login -->
    <NavbarView v-if="$route.path !== '/login'"  class="w-64 bg-gray-800 text-white sidebar" />
   
    <!-- Contenu principal -->
    <main class="flex-1 overflow-auto">
        <MobileNavbar  v-if="$route.path !== '/login'" class="mobile-navbar " />
      <router-view class="" />
     
    </main>
  </div>
</template>

<script>
import axios from 'axios';
import NavbarView from './components/NavbarView.vue';
import MobileNavbar from "./components/MobileNavbar.vue";

export default {
  components: {
    NavbarView,
    MobileNavbar
  },

  data() {
    return {
      activeTab: 1,  // Par défaut, le "Dashboard" est sélectionné
      isCollapsed: false,
    };
  },

  methods: {
    setActiveTab(tabIndex) {
      this.activeTab = tabIndex;
    },
    redirectToLogin() {
      this.$router.push('/login');
    }
  },

  mounted() {
    const token = localStorage.getItem('adminToken');
    if (!token) {
      this.redirectToLogin();
      return;
    }

    axios.get(
      'https://natureletjoli-c64a9b4f6da0.herokuapp.com/api/auth/verify-token',
      { headers: { Authorization: `Bearer ${token}` } }
    )
    .then(response => {
      console.log('Session valide :', response.data.user);
    })
    .catch(() => {
      console.warn('Session expirée ou token invalide.');
      localStorage.removeItem('adminToken');
      this.redirectToLogin();
    });
  }
};
</script>


<style>
#app {
  font-family: 'Poppins', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;

}

/* Masquer scrollbar sur tous les navigateurs */
.no-scrollbar {
  -ms-overflow-style: none;  /* IE & Edge */
  scrollbar-width: none;     /* Firefox */
}

.no-scrollbar::-webkit-scrollbar {
  display: none;             /* Chrome, Safari, Opera */
}

/* Pour une transition plus douce de la largeur */
.transition-width {
  transition-property: width;
  transition-duration: 0.3s;
  transition-timing-function: ease;
}

/* Media query pour écran < 768px (mobile) */
@media (max-width: 767px) {
  .sidebar {
    display: none !important;
  }
  .mobile-navbar {
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
}

@media (width > 767px) {
  .mobile-navbar {
    display: none;
  }
   .sm\:flex-row {
    display: flex !important;
    flex-direction: row !important; /* aligne en ligne */
  }
  .md\:flex-row {
    display: flex !important;
    flex-direction: row !important; /* aligne en ligne */
  }

}
</style>
